import React from 'react';

import Modal from './Modal';

const ModalAccountInfo = (props: {
	nameOutlet: string;
	outletCrew: string;
	scheduleTime: string;
	cancelButtonRef: React.MutableRefObject<null>;
	isShowModal: boolean;
	isLoading?: boolean;
	closeModal: () => void;
	closeModalBackground: () => void;
}) => {
	return (
		<Modal
			cancelButtonRef={props.cancelButtonRef}
			isShowModal={props.isShowModal}
			closeModalBackground={props.closeModalBackground}
		>
			<div className="text-left">
				<div className="mb-4">
					<div className="tablet:text-regular mobile:text-small text-gray-gray500 font-interSemiBold uppercase mb-1">
						Nama Outlet
					</div>
					<div className="tablet:text-large mobile:text-regular text-gray-gray700 font-interMedium">
						{props.nameOutlet}
					</div>
				</div>
				<div className="mb-4">
					<div className="tablet:text-regular mobile:text-small text-gray-gray500 font-interSemiBold uppercase mb-1">
						Outlet Crew
					</div>
					<div className="tablet:text-large mobile:text-regular text-gray-gray700 font-interMedium">
						{props.outletCrew}
					</div>
				</div>
				<div className="mb-4">
					<div className="tablet:text-regular mobile:text-small text-gray-gray500 font-interSemiBold uppercase mb-1">
						Tanggal/ Waktu
					</div>
					<div className="tablet:text-large mobile:text-regular text-gray-gray700 font-interMedium">
						{props.scheduleTime}
					</div>
				</div>
				<button
					ref={props.cancelButtonRef}
					type="button"
					onClick={props.closeModal}
					className="w-full h-11 text-center rounded-lg
        bg-primary-green focus:outline-none focus:ring-transparent focus:ring-primary-green"
				>
					<div className="laptop:text-large tablet:text-large mobile:text-regular text-white font-interSemiBold">
						Tutup
					</div>
				</button>
			</div>
		</Modal>
	);
};

export default ModalAccountInfo;
